import {Component, OnInit} from '@angular/core';
import {
    Photo,
    PhotoGallerySettings
} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {
    Animal,
    Rarity,
    Entry,
    Entries
} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {GoogleMapStyles, Park, Point} from "../../../../google-maps-points";
import {OlduvaiText} from "./olduvai-gorge.text";

@Component({
    selector: 'app-olduvai-gorge',
    templateUrl: './olduvai-gorge.component.html',
    styleUrls: ['./olduvai-gorge.component.css']
})
export class OlduvaiGorgeComponent implements OnInit {

    tripEntries: TripEntry[] = [
        new TripEntry({title: 'Big Buck', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
        new TripEntry({title: 'Lion\'s Share', route: '../../safari/lions-share-safari', iconName: 'lion'})
    ];

    parkText = new OlduvaiText();

    googleMapStyles = GoogleMapStyles; // pull from the global export
    strokeWeight = 5;
    zoom = 9; // default zoom level of the map
    mapLat = -2.8895554; // origin of the map
    mapLng = 35.38507607;

    // Animal Rarity Tooltips
    animalEntries: Entries = new Entries({
        entries:
            [
                new Entry({animal: Animal.Lion, rarity: Rarity.Common}),
                new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
                new Entry({animal: Animal.Baboon, rarity: Rarity.Common}),
                new Entry({animal: Animal.Giraffe, rarity: Rarity.Common}),
                new Entry({animal: Animal.Cheetah, rarity: Rarity.Common}),
                new Entry({animal: Animal.Warthog, rarity: Rarity.Common}),
                new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
                new Entry({animal: Animal.Jackal, rarity: Rarity.Uncommon}),
                new Entry({animal: Animal.EgyptianDuck, rarity: Rarity.Uncommon}),
                new Entry({animal: Animal.BlackRhino, rarity: Rarity.Rare})
            ]
    });

    // photo gallery metadata
    footprintGallery: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: '3.7 Million Year Old Footprint',
                    description: 'Hominins were walking here on two feet around 3.7 million years ago!',
                    thumbnailPath: '900x455/olduvai-footprint.jpg',
                    highresPath: '../../assets/img/others/olduvai-footprint.jpg',
                    altPhotoDescription: 'Hominin Footprint discovered in Olduvai Gorge',
                    attribution: 'John Reader/Science Photo Library'
                })
            ]
    });
    plainsGallery: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Surroundings of Olduvai',
                    description: 'Olduvai Gorge lies in the Ngorongoro Conservation Area.',
                    thumbnailPath: '700x465/olduvai-plains.jpg',
                    highresPath: '../../assets/img/others/olduvai-plains.jpg',
                    altPhotoDescription: 'Standing over 10,000 feet tall, Mount Lemakarot looms over the entrance to Ngorongoro Crater.',
                })
            ]
    });

    rockGallery: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Olduvai Geology',
                    description: 'Olduvai Gorge has a distinct rock formation showing the millions of years of erosion.',
                    thumbnailPath: '1920x1080/olduvai-sediment.jpg',
                    highresPath: '../../assets/img/1920x1080/olduvai-sediment.jpg',
                    altPhotoDescription: 'Standing over 10,000 feet tall, Mount Lemakarot looms over the entrance to Ngorongoro Crater.'
                })
            ]
    });

    oxpeckerPhoto: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Friends with Benefits',
                    description: 'An Oxpecker Bird rests on the horns of an African Buffalo. <br/><br/>' +
                        'Oxpeckers are known for their fluorescent colored beaks. ' +
                        'They graze on insects, wounds, and specks of dirt which have collected on the buffalo.',
                    thumbnailPath: '600x400/oxpecker-on-a-buffalo.jpg',
                    highresPath: '../../assets/img/others/oxpecker-on-a-buffalo.jpg',
                    altPhotoDescription: 'Oxpecker Bird on an African Buffalo'
                })
            ]
    });

  circleWidthsDesktop = ['2.5rem', '6rem', '6.5rem'];
  circleWidthsMobile = ['2.75rem', '7rem', '7.5rem'];

    parkBoundaries = [
        new Park({
            name: 'Olduvai Gorge',
            contentId: '/national-parks/olduvai-gorge',
            defaultColor: '#e14658',
            hoverColor: '#AD9F00',
            tooltipOrigin: new Point({lng: 35.38507607, lat: -2.8895554}),
            points:
                [
                    new Point({lng: 35.34889698, lat: -3.11966968}),
                    new Point({lng: 35.33250332, lat: -3.06929854}),
                    new Point({lng: 35.32907009, lat: -2.92198451}),
                    new Point({lng: 35.33001423, lat: -2.90687012}),
                    new Point({lng: 35.37370350, lat: -2.88955542}),
                    new Point({lng: 35.40777828, lat: -2.90069857}),
                    new Point({lng: 35.43958073, lat: -3.05698431}),
                    new Point({lng: 35.35868168, lat: -3.11366986})
                ]
        })
    ];

    constructor() {
    }

    ngOnInit() {
    }

    isMobile() {
        return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
    }

    mobileZoom() {
        if (document.body.clientWidth < 500) {
            return 7;
        }
        return this.zoom;
    }

    isMobileBr() {
        return document.body.clientWidth < 500;
    }

}
